<template>
  <div class="select_dialog_embed">
    <div class="platform_list_embed_msg" :class="{'select_dialog_embed_box_wper90': showType === 'pAnnounceDetail'}">
      <div class="select_dialog_embed_box">
        <!--弹出框头部-->
        <div class="select_dialog_embed_box_top">
          <p>{{title}}</p>
        </div>

        <!--弹出框信息-->
        <div class="select_dialog_embed_box_content">
          <!--公告详情-->
          <div v-if="showType === 'pAnnounceDetail'" class="select_dialog_embed_box_handle">
            <p class="title">{{announceDetail.Title}}</p>
            <p class="times">{{announceDetail.PubTime | time}}</p>
            <div v-html="announceDetail.Content">
              <!--{{announceDetail.Content}}-->
            </div>
          </div>
        </div>

        <!--弹出框底部-->
        <div class="select_dialog_embed_box_bottom">
          <button class="btn_cancel" @click="submitBtn()">关闭</button>
        </div>
      </div>

      <!--信息提示框-->
      <msg-dialog v-if="isShowMsgDialog" :txt="errorTxt" @closebtn="closeMsgDialog"></msg-dialog>
    </div>
  </div>
</template>

<script type="es6">
  import MsgDialog from '../../public-component/msg-dialog';
  export default {
    name: 'platform-list-embed-msg',
    /**
     *  title：  头部名
     *  showType: pAnnounceDetail=平台公共公告信息
     *  announceMsgId: 公告信息id
     * */
    props: ['title', 'showType', 'announceMsgId'],
    components: {MsgDialog},
    data() {
      return {
        announceDetail: '', // 公告详情
        errorTxt: '', // 错误提示
        isShowMsgDialog: false, // 是否显示信息提示框
        time: 3, // 倒计时时间
        timer: null // 计时器
      }
    },
    methods: {
      // 查看公告详情
      getPlatNoticeById() {
        this.$axios.post(this.Global.getPlatNoticeById(this.announceMsgId), null).then((res) => {
          console.log(res);
          if (!res.data.errorMsg.length) {
            this.announceDetail = res.data.resData;
          } else {
            this.isShowMsgDialog = true;
            this.errorTxt = res.data.errorMsg;
          }
        });
      },

      // 提交按钮
      submitBtn() {
        this.cancelBtn(this.showType, true);

        // 计时器
        if (this.isShowMsgDialog) {
          this.time = 3;
          const self = this;
          this.timer = setInterval(function () {
            self.time = --self.time;
            if (self.time < 1) {
              self.isShowMsgDialog = false;
              clearInterval(self.timer);
            }
          }, 1000);
        }
      },

      // 取消按钮
      cancelBtn(showType, issure) {
        this.$emit('cancelbtn', {isShow: false, issure: issure, showType: showType});
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isShowMsgDialog = e;
      }
    },
    created() {
      this.getPlatNoticeById();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .platform_list_embed_msg {
    max-height: 100%;

    &.select_dialog_embed_box_wper90 {
      width: 90%;
      min-width: 580px;

      .select_dialog_embed_box {
        width: 100%;

        .select_dialog_embed_box_handle {
          width: 80%;
          /*height: 400px;*/
          /*height: 595px;*/
          min-height: 380px;
          max-height: 500px;
          padding: 0 10%;
          margin: 10px auto 0;
          overflow-y: auto;

          .title {
            font-size: 20px;
            font-weight: bold;
            text-align: center;
            padding: 15px 0;
          }

          .times {
            text-align: right;
            margin-right: 15%;
            padding-bottom: 10px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/announcement/platform-list-embed-msg.vue